import { Quote } from "lucide-react";

const testimonials = [
  {
    name: "Sunil Narula",
    text: "My experience working with Vin Grace has been excellent. The Sehgals have been wonderful to work with. The Company installed a stairlift from the ground floor to the first floor. The staff is professional, courteous and efficient.",
    rating: 5,
  },
  {
    name: "Shakti Sachdeva",
    text: "Wonderful experience to visit the showroom in Lajpat Nagar, Delhi. Owner as well as staff are humble in nature. They explained everything in detail. We instantly approved & installed in our house. Excellent option for chair lift.",
    rating: 5,
  },
  {
    name: "Rakesh Ravi",
    text: "Recently we got chair lift installed through Vingrace at our home in Patna for elderly parents. We received a responsive service and needed help in making right decision. Installation was swift and completed in a day.",
    rating: 5,
  },
  {
    name: "Anand Bajaj",
    text: "I purchased a stair climbing chair from Vin Grace and am extremely satisfied with the product and service. A special mention to Mr. Sameer for his excellent management. The technical staff was skilled and professional.",
    rating: 5,
  },
  {
    name: "Hodophile Neha",
    text: "Recently I bought stair lift for my father. It's easy to operate. The installation was done on time. Thanks to Shrey and his team for services. We can rely on.",
    rating: 5,
  },
  {
    name: "Indu Khanna",
    text: "Job well executed.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-16 sm:py-20 bg-stone-50/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-700 mb-3 text-center">Customer Stories</p>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-stone-900 text-center font-['Outfit']">
          What Our Customers Say
        </h2>
        <p className="mt-3 text-stone-500 text-center">Real reviews from real families across India</p>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="rounded-2xl border border-stone-200 bg-white p-6 hover:shadow-md transition-shadow"
            >
              <Quote className="w-6 h-6 text-teal-200 mb-3" />
              <p className="text-stone-600 text-sm leading-relaxed line-clamp-4">{t.text}</p>
              <div className="mt-4 pt-4 border-t border-stone-100 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-teal-100 flex items-center justify-center">
                  <span className="text-teal-800 font-semibold text-sm">{t.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-stone-900 font-semibold text-sm">{t.name}</p>
                  <div className="flex gap-0.5 mt-0.5">
                    {[1,2,3,4,5].map(s => (
                      <svg key={s} className="w-3 h-3 text-amber-500" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
